<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-handshake-outline"
    />
    <router-view

      @setPageMode="setPageMode"
      @cancel="headlineText = $t('condAdmin.partnerOfTheWeekList.headline')"
    ></router-view>
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline.vue';
import condAdminPartnerOfTheWeekMixin from './js/condAdminPartnerOfTheWeekMixin.js';

export default {
  name: 'PartnerOfTheWeek',
  mixins: [ condAdminPartnerOfTheWeekMixin ],
  components: {
    Headline
  },
  data () {
    return {
      pageMode: 'view', // values: table, edit
      headlineText: this.$t('condAdmin.partnerOfTheWeekList.headline')
    };
  },
  async mounted () {
    console.debug('PartnerOfTheWeek.vue mounted');
    // nur Aufruf bei Seitenwechsel
    if (this.$store.state.condAdmin.clientKey == null) {
      // this.initClient();
    } else { // wenn keine Änderung des "aktuell administrierten Kontos erfolgt ist
      if (this.$store.state.condAdmin.administratableClientKey !== this.$store.state.base.admin.administratedOrg.uid) {
        await this.refreshPartnerOfTheWeekList();
      } else {
        this.clientVerified = true;
      }
    }
  },
  watch: {
    '$store.state.base.admin.administratedOrg': function () {
      this.$logger.debug('condAdmin', 'getPartnerOfTheWeek watch !!!');
      this.refreshPartnerOfTheWeekList();
      if (!this.$route.path.endsWith('/condAdmin/partnerOfTheWeek')) this.$router.push('/condAdmin/partnerOfTheWeek');
      // this.setPageMode('table');
    }
  },
  methods: {
    setPageMode (mode, headlineParam = '') {
      this.pageMode = mode;
      switch (mode) {
        case 'edit':
          this.headlineText = this.$t('condAdmin.partnerOfTheWeekList.headline') + ' - ' + this.$t('condAdmin.partnerOfTheWeekList.edit');
          break;
        case 'copy':
        case 'new':
          this.headlineText = this.$t('condAdmin.partnerOfTheWeekList.create');
          break;
        case 'view':
          this.headlineText = /* this.$t('condAdmin.conditionList.conditionEdit') + ': ' + */ headlineParam;
          break;
        default: // 'table':
          this.headlineText = this.$t('condAdmin.partnerOfTheWeekList.headline');
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
